export default "__VITE_ASSET__BbGhe4ZK__"